// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"152":"5e2a4920","351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"152":"456896b0e223d8be0399","351":"ee500c464f8d0ec5086c","678":"09df318192cd6139a678","883":"ce13c0f5d6192bb42018"}[chunkId] + ".js";
};